<!-- Center canvas: summary, text typed into directly - whole card is one pinnable region -->
<div class="cr-rv-card" *ngIf="isPreview" [id]="block.blockId">
  <span class="cr-rv-badge">Reviews</span>

  <span
    class="cr-rv-name"
    [appInlineEdit]="block.variables?.ReviewsPropertyName ?? ''"
    [inlineEditBlockId]="block.blockId"
    inlineEditPlaceholder="Insert property name"
    (inlineEditChange)="onChange($event, 'ReviewsPropertyName')"
  ></span>

  <div
    class="cr-rv-dropzone"
    [appInlineMedia]="block.variables?.['ReviewsImage']"
    [inlineMediaBlockId]="block.blockId"
    (inlineMediaChange)="onChange($event, 'ReviewsImage')"
  >
    <a *ngIf="block.variables?.['ReviewsImage']; else emptyPreview" [href]="previewHref" target="_blank" rel="noopener">
      <img [src]="block.variables?.['ReviewsImage']" [alt]="block.variables?.['ReviewsImageAlt'] || ''" />
    </a>

    <ng-template #emptyPreview>
      <div class="cr-inline-media-icon">
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
          <path d="M12 19.2V11.7" />
          <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
        </svg>
      </div>
      <div class="cr-inline-media-title">Upload image</div>
      <div class="cr-inline-media-subtitle">PNG up to 2 mb</div>
    </ng-template>
  </div>

  <span
    class="cr-rv-text"
    [appInlineEdit]="block.variables?.ReviewsText ?? ''"
    [inlineEditBlockId]="block.blockId"
    inlineEditPlaceholder="Insert review text"
    [inlineEditMultiline]="true"
    (inlineEditChange)="onChange($event, 'ReviewsText')"
  ></span>
</div>

<!-- Right panel: real edit form -->
<div class="cr-rv-edit" *ngIf="!isPreview">
  <div class="cr-rv-field-row">
    <span class="cr-rv-field-label">Image</span>
    <span
      class="cr-rv-toggle"
      [class.cr-rv-toggle-on]="imageAsUpload"
      role="button"
      tabindex="0"
      [title]="imageAsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
      (click)="toggleImageMode()"
      (keydown.enter)="toggleImageMode()"
      (keydown.space)="toggleImageMode()"
    ></span>
  </div>
  <div class="cr-rv-image-field">
    <app-block-text
      [maxLength]="500"
      type="link"
      [blockData]="block.variables?.['ReviewsImage'] ?? ''"
      (handleOnChange)="onChange($event, 'ReviewsImage')"
      [placeholder]="imagePlaceholder"
      variable="ReviewsImage"
      [isImage]="imageAsUpload"
      [isPlainText]="true"
      [blockId]="block.blockId"
    ></app-block-text>
    <div class="cr-rv-empty-overlay" *ngIf="imageAsUpload && !block.variables?.['ReviewsImage']">
      <div class="cr-rv-icon">
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
          <path d="M12 19.2V11.7" />
          <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
        </svg>
      </div>
      <div class="cr-rv-title">Upload image</div>
      <div class="cr-rv-subtitle">PNG up to 2 mb</div>
    </div>
  </div>

  <div class="cr-rv-link-field">
    <app-field-editor-v2
      [maxLength]="500"
      type="action-link"
      [blockData]="block.variables?.['ReviewsImageHref'] ?? ''"
      (handleOnChange)="onChange($event, 'ReviewsImageHref')"
      [placeholder]="imageHrefPlaceholder"
      variable="ReviewsImageHref"
      (handleOnSegmentChange)="handleOnSegmentChange($event, 'ReviewsImageHrefSegmentRegex')"
      [selectedSegment]="block.variables?.['ReviewsImageHrefSegmentRegex'] ?? ''"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>

  <app-field-editor-v2
    type="alt"
    [blockData]="block.variables?.['ReviewsImageAlt'] ?? ''"
    (handleOnChange)="onChange($event, 'ReviewsImageAlt')"
    [placeholder]="imageAltPlaceholder"
    [maxLength]="500"
    variable="ReviewsImageAlt"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <app-field-editor-v2
    type="content"
    [blockData]="block.variables?.['ReviewsPropertyName'] ?? ''"
    (handleOnChange)="onChange($event, 'ReviewsPropertyName')"
    [placeholder]="propertyNamePlaceholder"
    [maxLength]="500"
    variable="ReviewsPropertyName"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <app-field-editor-v2
    type="content"
    [multiline]="true"
    [showCounter]="true"
    [blockData]="block.variables?.['ReviewsText'] ?? ''"
    (handleOnChange)="onChange($event, 'ReviewsText')"
    [placeholder]="textPlaceholder"
    [maxLength]="4000"
    variable="ReviewsText"
    [disabled]="disabled"
  ></app-field-editor-v2>
</div>
